var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeHide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.207 1.793a1 1 0 0 0-1.414 1.414l15 15a1 1 0 0 0 1.414-1.414l-15-15ZM.239 9.324C1.196 7.952 2.257 6.8 3.406 5.881l2.831 2.831a4 4 0 0 0 5.117 5.117l2.225 2.225a10.05 10.05 0 0 1-3.592.68c-1.99 0-3.903-.584-5.68-1.735-1.578-1.022-2.995-2.472-4.095-4.194a1.33 1.33 0 0 1 .027-1.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.334 10.066c0-.083.004-.165.011-.246l2.902 2.902a2.667 2.667 0 0 1-2.912-2.655Zm2.543-2.664 2.788 2.788a2.667 2.667 0 0 0-2.788-2.788Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.067c0 .43-.07.854-.203 1.255l2.916 2.916a14.252 14.252 0 0 0 3.077-3.448 1.342 1.342 0 0 0-.004-1.448c-1.103-1.705-2.533-3.154-4.137-4.19C13.877 4.007 11.918 3.4 9.988 3.4c-1.17 0-2.326.22-3.455.657L8.744 6.27a3.998 3.998 0 0 1 5.257 3.798Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeHide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-hide.b11c846c943e785f172265d18782757a.svg";